const MIME_TYPE_MAP: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/jpeg',
  gif: 'image/jpeg',
  webp: 'image/jpeg',
  bmp: 'image/jpeg',
  tiff: 'image/jpeg',
  svg: 'image/svg+xml',
}

export const getMimeTypeFromExtension = (ext: string): string | undefined => {
  if (!ext) {
    return undefined
  }
  const cleanExt = ext.toLowerCase().replace(/^\./, '')

  return MIME_TYPE_MAP[cleanExt]
}

export const getFileExtensionFromUrl = (url: string): string | undefined => {
  if (!url) {
    return undefined
  }

  const urlWithoutParams = url.split('?')[0].split('#')[0]
  const lastDotIndex = urlWithoutParams.lastIndexOf('.')

  if (lastDotIndex === -1 || lastDotIndex === urlWithoutParams.length - 1) {
    return undefined
  }

  const extension = urlWithoutParams.substring(lastDotIndex + 1).toLowerCase()

  return extension || undefined
}

export const getFileNameFromUrl = (url: string): string | undefined => {
  if (!url) {
    return undefined
  }

  const urlWithoutParams = url.split('?')[0].split('#')[0]

  const fileName = urlWithoutParams.split('/').pop()

  if (!fileName) {
    return undefined
  }

  return decodeURIComponent(fileName)
}

export const downloadFileFromBuffer = (
  buffer: ArrayBuffer,
  fileName: string,
  mimeType?: string,
): void => {
  const blob = new Blob([buffer], { type: mimeType })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

export const downloadFileFromUrl = async (fileUrl: string, fileName?: string): Promise<void> => {
  const response = await fetch(fileUrl)
  const blob = await response.blob()
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  const downloadFileName = fileName || getFileNameFromUrl(fileUrl)

  if (downloadFileName) {
    link.setAttribute('download', downloadFileName)
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
